import axios from "axios"
import { StudentNotification, StudentNotificationStatus } from "shared/types/notificationTypes"

export interface StudentNotificationsReturn {
    totalCount: number
    filteredCount: number
    notifications: StudentNotification[]
}

export async function getStudentNotifications({ pageNumber, showRead } : { pageNumber: number | null, showRead: boolean }): Promise<StudentNotificationsReturn> {
    const response = await axios.get("/api/student/notifications", { params: { pageNumber, showRead }})
    return response.data
}

export async function updateStudentNotificationStatus(notificationId: string, status: StudentNotificationStatus): Promise<void> {
    await axios.put("/api/student/notifications", {
        notificationId: notificationId,
        status: status,
    })
}
